<template>

    <transition name="modal" appear>

        <template v-if="!isStarting">

            <div class="modal-mask">

                <div class="modal-wrapper">

                    <div class="modal-container">

                        <div class="model-actions">
                            <div class="modal-close-button" @click="closeModal" title="close">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#292c34"></path></svg>
                            </div>
                        </div>

                        <div class="modal-header">
                            Label: {{ this.$store.state.modalHeader }}
                        </div>

                        <div class="modal-body">

                            <!--
                            <ul class="langAbbr">
                                <li v-for="(value, key, index) in fields">
                                    <a @click.prevent="showField=key, activeBtn=index" :class="{active: activeBtn == index }">{{ key }}</a>
                                </li>
                            </ul>
                            -->

                            <form @keyup.enter.stop="submitForm">

                                <div class="control">
                                    <div v-for="(value, key, index) in fields" v-show="showField==key || !showField && index==0">
                                        <!-- {{ fields[key] }} -->
                                        <input class="input" :key="key" type="text" v-model="fields[key]" :placeholder="$store.state.modalHeader">
                                    </div>
                                </div>

                            </form>

                        </div>

                        <div class="modal-footer is-clearfix">
                            <button class="button is-primary is-pulled-right" :class="{ 'is-loading': isSaving }" @click="submitForm">{{ $t("speichern") }}</button>
                        </div>

                    </div>  <!-- // modal-container -->

                </div> <!-- // modal-wrapper -->

            </div> <!-- // modal-mask -->
        </template>

        <template v-else>

            <div class="modal-loading-mask">
                <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
            </div>

        </template>

    </transition>

</template>

<script>


export default {

    data: function() {
        return {
            activeBtn: '',
            showField: false,
            isSaving: false,
            isStarting: false,
            labelID: false,
            fields: {
                de: null,
                en: null,
                fr: null,
                it: null
            }
        }
    },

    created: function() {

        this.labeldID = "";
        // fetch labels for this labelKey

        this.fetchData();

        // add eventListener for "ESC" Key
        document.addEventListener("keydown", this.onKeyDown);
    },

    beforeDestroy: function () {
        // remove the "ESC" Eventlistener
        document.removeEventListener('keydown', this.onKeyDown);
    },

    methods: {

        onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this.closeModal();
            }
        },

        closeModal: function() {
            this.$store.commit("closeModal");
        },

        submitForm: function() {

            this.isSaving = true;
            var self = this;
            var labelKey = this.$store.state.modalHeader;


            // loop through object and set empty strings to key
            for (var key in this.fields) {
                if(this.fields[key] == "") {
                    this.fields[key] = this.$store.state.modalHeader;
                }
            }

            // UPDATE
            if(this.labelID)
            {
                var apiURL = this.$config.api + 'label/'+this.labelID;
                var saveObj = {
                    "id": this.labelID,
                    "app": "cms",
                    "name": labelKey,
                    "value": this.fields
                }

                this.axios.put(apiURL, saveObj)
                    .then(function(response) {

                        self.$store.dispatch('fetchLabels', self.$store.state.currentLang).then(() => {
                            self.isSaving = false;
                            self.closeModal();
                        });

                    })
                    .catch(function(error) {
                        self.isSaving = false;
                        console.log("ERROR: " + error);
                    });
            }

            // INSERT
            else
            {
                var apiURL = this.$config.api + 'label';
                var saveObj = {
                    "app": "cms",
                    "name": labelKey,
                    "value": this.fields
                }

                this.axios.post(apiURL, saveObj)
                    .then(function(response) {

                        self.$store.dispatch('fetchLabels', self.$store.state.currentLang).then(() => {
                            self.isSaving = false;
                            self.closeModal();
                        });

                    })
                    .catch(function(error) {
                        self.isSaving = false;
                        console.log("ERROR: " + error);
                    });

            }

        },

        fetchData: function() {

            this.isStarting = true;
            var self = this;
            let labelKey = this.$store.state.modalHeader;

            this.axios.get(this.$config.api + 'label/valueListByName?app=cms&name='+labelKey+'&'+Date.now())
                .then(function(response) {

                    var keyword = self.$store.state.modalHeader;

                    if(typeof response.data[keyword] != 'undefined') {

                        self.labelID = response.data[keyword].id;

                        Object.keys(response.data[keyword]['lang']).forEach(function(key) {
                            if(response.data[keyword]['lang'][key] != null && response.data[keyword]['lang'][key] != '') {
                                self.fields[key] = response.data[keyword]['lang'][key]
                            }
                        });

                        self.isStarting = false;

                    } else {
                        self.isStarting = false;
                    }

                })
                .catch(function(error) {
                    console.log("ERROR: " + error);
                });

        }

    }

}
</script>


<style>

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        position: relative;
        width: 80%;
        max-width: 640px;
        margin: 0 auto;
        padding: 15px 25px;
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }
    .modal-header {
        margin: -15px -25px 0;
        padding: 15px;
        height: 50px;
        background: #dee5eb;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }
    .modal-body {
        margin: 20px 0 10px 0;
    }
    .modal-default-button {
        float: right;
    }

    .modal-container .model-actions {
        position: absolute;
        top: 12px;
        right: 12px;
    }
    .modal-close-button svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-top: -2px;
        cursor: pointer;
        transition: opacity .2s ease;
    }
    .modal-close-button svg:hover {
        opacity: 0.5;
    }
    .modal-loading-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
        display: table;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: opacity .5s ease;
    }

    /* spoke shortcuts */
    .modal-container .langAbbr {
        display: flex;
        justify-content: flex-end;
        margin: 0 0 4px 0;
    }
    .modal-container .langAbbr li {
    }
    .modal-container .langAbbr li a {
        text-transform: uppercase;
        padding: 10px;
    }
    .modal-container .langAbbr li a.active {
        font-weight: bold;
    }
    .modal-container .langAbbr li a:last-child {
        padding-right: 0;
    }


</style>
